import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';

export interface CheckState {
    pendingCount: number | null;
    /** 等待处理的打卡数据 */
    signIn: Check.SignIn | null;
}

const m: Module<CheckState, RootState> = {
    namespaced : true,
    state: () => ({
        pendingCount: null,
        signIn: null,
    }),
    mutations: {
        /**
         * 记录待审核数量
         */
        setPendingCount(state, pendingCount) {
            state.pendingCount = pendingCount;
        },
        /**
         * 记录signIn
         */
        setSignIn(state, signIn) {
            state.signIn = signIn;
        },
    },
    actions: {
        async getPendingCount({ state, commit }, participationId = null) {
            const params: {
                [key: string]: any;
            } = {};
            if (participationId) {
                params.participation_id = participationId;
            }
            const response = await Vue.axios.get('/api/v1/participation/check_sign_in_count', {
                params,
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setPendingCount', rdata.data);
            }
            return rdata;
        },
        /**
         * 获取审核内容
         */
        async getSignIn({ state, commit }, { participationId }) {
            const response = await Vue.axios.get('/api/v1/participation/check_sign_in', {
                params: {
                    participation_id: participationId,
                },
            });
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setSignIn', rdata.data);
            }
            return rdata;
        },
        /**
         * 判决
         */
        async judge({ state, commit }, { signInId, action, reason }) {
            const response = await Vue.axios.post('/api/v1/participation/check_sign_in', {
                id: signInId,
                action,
                reason,
            });
            return response.data;
        },
    },
};

export default m;
